const cache = {}; // global in-memory cache

export function getCache(key) {
  const entry = cache[key];
  if (!entry) return null;

  const now = Date.now();
  if (entry.expires < now) {
    delete cache[key]; // expired
    return null;
  }

  return entry.data;
}

export function setCache(key, data, ttlMs) {
  cache[key] = {
    data,
    expires: Date.now() + ttlMs,
  };
}
